export default "__VITE_ASSET__CHkU$TEw__"